import fireErrorAnalytics, {
	type ErrorPayload,
	trackFetchErrors,
	type AnalyticsPayload,
} from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors';
import { JsdFetchError } from '../fetch/requests';

export const ANALYTIC_CONTEXTS = {
	AUTOMATION_SETTINGS: 'AutomationSettings',
	KNOWLEDGE: 'Knowledge',
	QUEUES: 'Queues',
	CSAT: 'Csat',
} as const;

export const ttrRecommendedSlo = 1000;
export const ttiRecommendedSlo = 4000;

export const trackJsdFetchErrors = async (payload: ErrorPayload) => {
	const { error, attributes } = payload;
	if (error instanceof JsdFetchError) {
		const { reasonKey } = error;
		trackFetchErrors({
			...payload,
			attributes: { ...attributes, reasonKey },
		});
		return;
	}
	trackFetchErrors(payload);
};

export function fireJsonOnlyErrorAnalytics({
	error,
	...rest
}: Omit<AnalyticsPayload, 'error'> & { error: unknown }) {
	let tempError = error;

	if (error instanceof Error) {
		try {
			JSON.parse(error.message);
		} catch (e) {
			if (error instanceof FetchError) {
				// cloning as we're unable to mutate the original message property
				tempError = new FetchError(
					error?.statusCode,
					`Error server response: ${error?.statusCode}`,
					error?.traceId,
					error?.originalResponse,
				);
			} else {
				// Strip the message incase it contains sensitive information
				tempError = new Error('');
			}
		}
	}

	fireErrorAnalytics({
		error: tempError instanceof Error ? tempError : undefined,
		...rest,
	});
}
